import colors from '../../../../../config/colors'
import { shortFormatNumber } from '../../util'
import { ColorVariant } from '../checkbox'
import { FinancialsRowDataType } from '../financials-table/types'
import { ChartData, View } from './types'

export function getColor(color: ColorVariant) {
  switch (color) {
    case ColorVariant.violet:
      return colors.violet[400]
    case ColorVariant.emerald:
      return FinvizSettings.hasDarkTheme ? colors.emerald[300] : colors.emerald[400]
    case ColorVariant.orange:
      return colors.orange[300]
    case ColorVariant.teal:
      return FinvizSettings.hasDarkTheme ? colors.teal[300] : colors.teal[400]
    case ColorVariant.pink:
      return colors.pink[400]
    case ColorVariant.lime:
      return FinvizSettings.hasDarkTheme ? colors.lime[300] : colors.lime[400]
    case ColorVariant.purple:
      return colors.purple[400]
    case ColorVariant.green:
      return colors.green[400]
    case ColorVariant.yellow:
      return FinvizSettings.hasDarkTheme ? colors.yellow[200] : colors.yellow[300]
    case ColorVariant.blue:
      return FinvizSettings.hasDarkTheme ? colors.blue[300] : colors.blue[400]
    case ColorVariant.red:
      return colors.red[400]
    case ColorVariant.gray:
      return colors.gray[400]
    case ColorVariant.dark:
      return FinvizSettings.hasDarkTheme ? colors.gray[200] : colors.gray[800]
    default:
      return 'red'
  }
}

export function tickFormatter(value: any) {
  return shortFormatNumber(value, { fractions: 0 })
}

export function getChartDataItemKey(item: Pick<FinancialsRowDataType, 'id' | 'label'>) {
  return item.id || item.label
}

export function getChartData(data: FinancialsRowDataType[], yearKeys: string[], chartView: View) {
  /*
   * Bar chart renders segments from the bottom up, so the sorting of visible areas is correct here
   * assuming it's sorted by column values
   * */
  const visibleAreas = data.filter((item) => item.isSelected).map((item) => ({ ...item, color: getColor(item.color) }))
  /*
   * Line chart has reverse order because we need to render lines from the end so they don't cover main lines
   * you can think about it as visibleAreas index === zIndex on the chart
   * */
  if (chartView === View.lines) visibleAreas.reverse()

  const chartData = yearKeys.map((year) => {
    const stackedBar = { year, topKey: '', bottomKey: '', total: 0 } as ChartData

    visibleAreas.forEach((item) => {
      const valueKey = getChartDataItemKey(item)
      const value = item.values.find((v) => v.year === year)?.value ?? null
      stackedBar[valueKey] = value
      stackedBar.total += value ?? 0

      if (item.isSelected && value !== 0) {
        // top key is the key of latest area which is visible and have some positive value
        // bottom key is the key of latest area which is visible and have some negative value
        stackedBar[value && value > 0 ? 'topKey' : 'bottomKey'] = valueKey
      }
    })

    return stackedBar
  })

  return { chartData, visibleAreas }
}
